import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'cap' })
export class Capitalize implements PipeTransform {
  /** * * @param value * @returns {string} */
  transform(value: string): string {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    else {
      return "NA";
    }
  }

}

// we can just use | titlecase which is a built in pipe in angular